import React from "react";
import FilterWrapper from "./FilterWrapper";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { twMerge } from "tailwind-merge";

type Props<T extends string | undefined> = {
  icon: React.ReactNode;
  title: string;
  value: T;
  setValue: (value: T) => void;
  options: Array<{
    label: string;
    value: string;
  }>;
};

const FilterSelect = <T extends string | undefined>({
  icon,
  title,
  value,
  setValue,
  options,
}: Props<T>) => {
  return (
    <FilterWrapper icon={icon} title={title}>
      <Select
        value={value}
        onValueChange={(value) => {
          if (value) {
            setValue(value as T);
          } else {
            setValue(undefined as T);
          }
        }}
      >
        <SelectTrigger
          aria-label={title}
          className={twMerge(
            "w-full",
            (!value || value === "ANY") && "text-muted-foreground"
          )}
        >
          <SelectValue className="text-sm" placeholder={title} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {options.map((option) => (
              <SelectItem
                className="text-sm"
                key={option.value}
                value={option.value}
              >
                {option.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </FilterWrapper>
  );
};

export default FilterSelect;
